import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEspectaculoById } from 'services/servicioGet';
import { Espectaculo } from 'utils/models/types';

interface EspectaculoPorIdState {
  espectaculo: Espectaculo;
  loadingEspectaculo: boolean;
  errorEspectaculo: string | null;
}

// Estado inicial
const initialStateEspectaculo = {
  Id: 0,
  VisibleEnGrilla: true,
  Nombre: '',
  Descripcion: '',
  Afiche: '',
  Fotos: [],
  Sala: null,
  SalaId: 1,
  AforoDisponible: 0,
  Elenco: '',
  Autor: '',
  Director: '',
  Genero: null,
  GeneroId: 1,
  Precio: 0,
  Banner: '',
  BannerDestacado: false,
  AsistenteDireccion: '',
  Vestuarista: '',
  Iluminador: '',
  Sonidista: '',
  Musica: '',
  DisenoGrafico: '',
  Fotografia: '',
  Escenografia: '',
  Traduccion: '',
  PorcentajeAgadu: 0,
  PorcentajeCofonte: 0,
  TipoElencoId: 1,
};

// Estado inicial del slice
const initialState: EspectaculoPorIdState = {
  espectaculo: initialStateEspectaculo,
  loadingEspectaculo: false,
  errorEspectaculo: null,
};

// Thunk para obtener el espectáculo
export const fetchEspectaculoPorId = createAsyncThunk<
  Espectaculo,
  number, // Id del espectáculo
  { rejectValue: string }
>('espectaculos/fetchEspectaculoPorId', async (id, thunkAPI) => {
  try {
    const response = await getEspectaculoById(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar el espectáculo');
  }
});

// Slice de espectaculo por id
const espectaculoPorIdSlice = createSlice({
  name: 'espectaculo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchEspectaculoPorId.pending, state => {
        state.loadingEspectaculo = true;
        state.errorEspectaculo = null;
      })
      .addCase(fetchEspectaculoPorId.fulfilled, (state, action) => {
        state.espectaculo = action.payload;
        state.loadingEspectaculo = false;
      })
      .addCase(fetchEspectaculoPorId.rejected, (state, action) => {
        state.loadingEspectaculo = false;
        state.errorEspectaculo = action.payload as string;
      });
  },
});

export default espectaculoPorIdSlice.reducer;
